import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
const MemberChangePopup = ({ open, handleClose, removeData, editData, removeFromCart }: any) => {
  return (
    <ReactModal isOpen={open} onRequestClose={handleClose} className="my_acc_modal" overlayClassName="my_acc_overlay">
      <div>
        <div className="cross_button">
          <img src="/assets/img/my-profile/cross.png" alt="" className="cursor-pointer" onClick={handleClose} />
        </div>
        <div className="acc_modal_content">
          <h6 className="pb-3">Member Change</h6>
          <p className="mb-2">These selected tests are not applicable for the selected gender:</p>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th style={{ minWidth: "60px" }}>SNo.</th>
                <th style={{ minWidth: "80px" }}>Item Code</th>
                <th style={{ minWidth: "80px" }}>Item Name</th>
                <th style={{ minWidth: "80px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {removeData &&
                removeData?.map((ele: any,index:number) => (
                  <tr>
                    <td style={{ minWidth: "60px" }}>{index+1}</td>
                    <td style={{ minWidth: "80px" }}>{ele?.TestCode}</td>
                    <td style={{ minWidth: "80px" }}>{ele?.TestName}</td>
                    <td style={{ minWidth: "80px" }}><img src="/assets/img/my-profile/delete.png" onClick={() => removeFromCart(ele)} width={24} height={24} className="cursor-pointer"/></td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </ReactModal>
  );
};

export default MemberChangePopup;
